import { ArrowDownCircleIcon } from "@heroicons/react/24/solid";
const SideNavDownloadBtn = ({
  buttonValue = "Download",
  className = "",
  onClick,
  type = "button",
  disabled = false,
}) => {
  return (
    <button
      type={type}
      value={buttonValue}
      onClick={onClick}
      disabled={disabled}
      className={
        (disabled
          ? "cursor-not-allowed border text-quinary opacity-50  border-quinary "
          : "text-quinary") +
        `hover:scale-90 transition duration-500 hover:text-hquinary
        text-quinary group py-1 px-3 font-medium${className}`
      }
    >
      <div className="flex items-center flex-col">
        <ArrowDownCircleIcon className="h-4 w-4 mr-1" />
        <p className="text-xs"> {buttonValue}</p>
      </div>
    </button>
  );
};
export default SideNavDownloadBtn;
